import React, { useState } from 'react'
import { Stack, TextField, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import api from '../../../services/api'
import * as yup from 'yup'
import { translate } from '../../../i18n'
import { Button } from '../../../components/Button'
import Iconify from '../../../components/Iconify'
import { useTheme } from '@mui/material/styles'
import { useAppDispatch } from 'redux/hooks'
import { showMessage } from 'redux/reducers/snackbar/snackbar.actions'

const forgotAddCodeSchema = yup.object({
  code: yup
    .string()
    .trim()
    .required(() => translate('verification.required.code'))
    .min(6, () => translate('verification.required.codeSize'))
})

interface ForgotAddCodeProps {
  code: string
}

export interface ForgotAddCodeFormProps {
  username: string
  onSuccess: Function
}
export default function ForgotAddCodeForm ({ username, onSuccess }: ForgotAddCodeFormProps) {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgotAddCodeProps>({
    resolver: yupResolver(forgotAddCodeSchema)
  })

  const handleSend = async (dataPost: ForgotAddCodeProps) => {
    setLoading(true)
    try {
      const result = await api.post('/users/forgot-password/verify',
        { username, code: dataPost.code },
        { headers: { 'Content-Type': 'application/json' } })
      if (result) {
        dispatch(showMessage({ message: `${t('account.code_success')}` }))
        onSuccess(dataPost.code, result.data.id)
      }
    } catch (e) {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Stack alignItems="center" spacing={3}>
        <Iconify icon="quill:send" width={80} color={theme.palette.primary.main} />
        <Typography variant="h4">{t('forgot.titleCode')}</Typography>
        <Typography variant="body1" textAlign="center">{t('forgot.subtitleCode')}</Typography>
      </Stack>
      <Stack mb={2} mt={2}>
        <Controller
          control={control}
          name="code"
          render={({ field: { onChange } }) => (
            <TextField
              placeholder={t<string>('verification.field.code.placeholder')}
              label={t<string>('verification.field.code.label')}
              onChange={onChange}
              autoCapitalize="none"
              helperText={errors.code?.message}
              error={errors.code?.message !== undefined}
            />
          )} />
      </Stack>
      <Stack>
        <Button
          title={t('forgot.btn.reset')}
          isLoading={loading}
          onClick={handleSubmit(handleSend)}
        />
      </Stack>
    </>
  )
}
